export enum KeyboardIntent {
    None = 0,
    Delete = 1,
    Backspace = 2,
    Cut = 3,
    Paste = 4,
    Type = 5,
}
